import React, { Component } from 'react';

import AccountCircle from '@mui/icons-material/AccountCircle';
import {
  Container,
  TextField,
  MenuItem,
  FormControl,
  Typography,
  Button,
  Select,
  CssBaseline,
  Box,
  Avatar,
  InputLabel,
  Stack,
} from '@mui/material';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import './styles.css';

class Signup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      username: '',
      password: '',
      system: 'Development',
      client: 100,
    };
  }

  renderLogIn = () => {
    const { t } = this.props;
    const { username, password, system, client } = this.state;
    return (
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <Box
          sx={{
            marginTop: 8,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
            <AccountCircle />
          </Avatar>
          <Typography component="h1" variant="h5">
            {t('authScreenTranslations:SIGNUP')}
          </Typography>
          <Box sx={{ mt: 1 }}>
            <TextField
              sx={{ mb: 2 }}
              margin="normal"
              fullWidth
              name="username"
              label={t('authScreenTranslations:USERNAME')}
              value={username}
              onChange={e => this.setState({ username: e.target.value })}
            />
            <TextField
              sx={{ mb: 3 }}
              margin="normal"
              fullWidth
              name="password"
              label={t('authScreenTranslations:PASSWORD')}
              type="password"
              value={password}
              onChange={e => this.setState({ password: e.target.value })}
            />
            <FormControl fullWidth sx={{ mb: 3 }}>
              <InputLabel>{t('authScreenTranslations:SYSTEM')}</InputLabel>
              <Select
                value={system}
                label={t('authScreenTranslations:SYSTEM')}
                onChange={this.handleChange}
              >
                <MenuItem value="Development">{t('authScreenTranslations:DEV')}</MenuItem>
              </Select>
            </FormControl>
            <FormControl fullWidth sx={{ mb: 2 }}>
              <InputLabel>{t('authScreenTranslations:CLIENT')}</InputLabel>
              <Select
                value={client}
                label={t('authScreenTranslations:CLIENT')}
                onChange={this.handleChange}
              >
                <MenuItem value="100">100</MenuItem>
              </Select>
            </FormControl>
            <Stack direction="row" justifyContent="space-between" sx={{ mb: 2 }}>
              <Typography className="t-title" onClick={() => this.props.history.push('/signup')}>
                {t('authScreenTranslations:ALREADY_HAVE_AN_ACC')}
              </Typography>
              <Typography className="t-title" onClick={() => this.props.history.push('/signin')}>
                {t('authScreenTranslations:SIGNIN')}
              </Typography>
            </Stack>
            <Button
              fullWidth
              variant="contained"
              sx={{ mt: 1, mb: 2 }}
              onClick={() => this.props.history.push('/confirmcode', { isChangePassword: false })}
            >
              {t('authScreenTranslations:SIGNUP')}
            </Button>
          </Box>
        </Box>
      </Container>
    );
  };

  render() {
    const { location, auth } = this.props;
    const { loggedIn } = auth;

    return loggedIn ? (
      <Redirect to={{ pathname: '/', state: { from: location } }} />
    ) : (
      this.renderLogIn()
    );
  }
}

const mapStateToProps = state => {
  return {
    auth: state.auth,
  };
};

const cSignup = connect(mapStateToProps, {})(Signup);
const tSignup = withTranslation(['authScreenTranslations'])(cSignup);

export { tSignup as Signup };
